const features = [
  {
    icon: "ri-fire-line",
    title: "实时热点追踪",
    desc: "7×24小时不间断监控全网mrds热门话题，每日大赛新瓜第一时间送达，让你永远快人一步掌握榜单看点。",
  },
  {
    icon: "ri-shield-flash-line",
    title: "独家爆料深扒",
    desc: "深入挖掘mrds每日爆料背后的真相，榜单揭晓不只表面数据，更有黑料内幕与独家视角解读。",
  },
  {
    icon: "ri-emotion-laugh-line",
    title: "擦边搞笑合集",
    desc: "精选全网最搞笑的擦边内容，大赛每日更新让快乐不间断，放松心情的最佳娱乐伴侣。",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-10 text-center">
          为什么选择mrds
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div key={i} className="bg-background-100 rounded-2xl p-6 md:p-8 text-center group hover:bg-primary-50/50 transition-colors duration-300">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100">
                <i className={`${f.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-heading text-foreground-900 mb-3">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}